export let data = {
  title: "Input Tagihan Kamar Rawat Inap",
  backBtn: "/ranap",
  actionBtn: [],
  breadcrumb: [
    { title: "Rawat Inap", link: "/ranap" },
    { title: "Input Tagihan Kamar Rawat Inap", active: true }
  ]
};
export let dataEdit = {
  title: "Ubah Tagihan Kamar Rawat Inap",
  backBtn: "/ranap",
  actionBtn: [],
  breadcrumb: [
    { title: "Rawat Inap", link: "/ranap" },
    { title: "Ubah Tagihan Kamar Rawat Inap", active: true }
  ]
};
export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" }
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)"
        },
        {
          colnum: 7,
          icon: "",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)"
        }
      ]
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 \nPerumnas Depok I Kel. Depok Jaya, \nKec. Pancoran Mas Depok, Jawa Barat"
        }
      ]
    }
  ]
};

export let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    columns: [
      {
        label: "No. Rawat",
        content: "2020/04/16/000001",
        icon: "apps",
        colwidth: 6
      },
      {
        label: "Unit",
        content: "MAT | Poliklinik Mata",
        icon: "apps",
        colwidth: 6
      }
    ]
  }
];
export let detailRightTop = [
  {
    label: "Dokter yang Dituju",
    content: "D00000026  |   dr. Azizah Masthura",
    icon: "apps"
  }
];

export let today=new Date();
import {getTime} from './helper.js';
export let time=getTime(today.getHours(),today.getMinutes());

export let leftForm = [
  {
    colnum: 2,
    columns: [
    //   {
    //     label: "Kamar",
    //     type: "select",
    //     placeholder: "Pilih Kamar",
    //     name: "id_kamar",
    //     value: "",
    //     mandatory: true,
    //     multiple: false,
    //     options: [
    //       {
    //         label: "Cempaka 1",
    //         value: "C1"
    //       }
    //     ],
    //     colwidth: "6"
    //   },
      {
        label: "Dari Tanggal",
        type: "date",
        placeholder: "Pilih tanggal awal",
        name: "tgl_dari",
        value: today,
        mandatory: true,
        additional: "",
        colwidth: "6"
      },
      {
        label: "Sampai Tanggal",
        type: "date",
        placeholder: "Pilih tanggal akhir",
        name: "tgl_sampai",
        value: today,
        mandatory: true,
        additional: "",
        colwidth: "6"
       }
    ]
  }
];

export let leftFormEdit = [
  {
    colnum: 3,
    columns: [
    //   {
    //     label: "Kamar",
    //     type: "select",
    //     placeholder: "Pilih Kamar",
    //     name: "id_kamar",
    //     value: "",
    //     mandatory: true,
    //     multiple: false,
    //     options: [
    //       {
    //         label: "Cempaka 1",
    //         value: "C1"
    //       }
    //     ],
    //     colwidth: "6"
    //   },
      {
        label: "Tanggal",
        type: "date",
        placeholder: "Pilih tanggal",
        name: "tgl",
        value: today,
        mandatory: true,
        additional: "",
        colwidth: "4"
      },
      {
        label: "Kamar",
        type: "select",
        placeholder: "Pilih Kamar",
        name: "id_kamar",
        value: "",
        mandatory: true,
        multiple: false,
        options: [

        ],
        additional: "",
        colwidth: "5"
      },
      {
        label: "Biaya",
        type: "money",
        placeholder: "",
        name: "biaya",
        value: "0",
        readonly:true,
        mandatory: true,
        additional: "",
        colwidth: 3
      },
    ]
  }
];